import httpClient from './httpClient';

export const employeeService = {
    checkReclaimation() {
        return httpClient.get('/api/adv/reclamation/check');
    },
    submitReclaimation(data) {
        return httpClient.post('/api/adv/reclamation', data);
    }
}

export default employeeService;